module.exports = {
  LifeCulture:'ဘဝနှင့် ယဉ်ကျေးမှု',
  LifeCultureTips1:'ရုပ်ဇာတ်ပုံများဖြင့် ဂျပန်နိုင်ငံ၏ နေ့စဉ်ဘဝနှင့် ယဉ်ကျေးမှုကို လေ့လာရှာဖွေပါ',
  LifeCultureTips2:'အသံထွက်နှင့်အသံအနိမ့်အမြင့်များ',
  Grammar:'သဒ္ဒါ',
  GrammarTips1:'နေ့စဉ်သုံး ဂျပန်စကားအတွက် အခြေခံသဒ္ဒါများကို သင်ယူပါ',
  Conversation:'စကားဝိုင်း',
  ConversationTips1:'တိုပြီးလွယ်ကူသော စကားပြောဗီဒီယိုများမှတစ်ဆင့် သင်ယူပါ',
  ConversationTips2:'စကားပြောဗီဒီယိုစာရင်း',
  '300 Sentences':'ဝါကျပေါင်း ၃၀၀',
  '300SentencesTips1':'နေ့စဉ်ဘဝ၊ သင်ကြားရေးနှင့် ခရီးသွားရာတွင် အသုံးဝင်သော တရုတ်စာကြောင်း ၃၀၀',
  'Basic Hiragana':'အခြေခံ ဟိရာဂနာ',
  'Basic Chinese Hiragana':'အခြေခံ တရုတ် ဟိရာဂနာ',
  'BasicHiraganaTips1':'သင့်ရဲ့ အသံအနိမ့်အမြင့် (သံ) နှင့် ဖင်ယင် အသံထွက်ကို စမ်းသပ်လိုက်ပါ',
  HiraganaTips:'အခုချိန်ထိ ဝင်ရောက်ခွင့် မရသေးပါ',
  'Learn':'လေ့လာသင်ယူပါ',
  'Watch':'ကြည့်ပါ',
  'Recommended':'အကြံပြုချက်',
  NoGameList:'အခြေခံ ဟိရာဂနာ မရှိပါ!',
  "Sample Sentence":"နမူနာစာကြောင်း",
  "Ques No":"မေးခွန်းနံပါတ်",
  "Correct Answer":"အဖြေမှန်",
  "Your Answer":"သင့်ရဲ့အဖြေ",
  "Your Result":"သင့်ရဲ့ရလဒ်",
  "Final Result":"နောက်ဆုံးရလဒ်",
  "Previous":"ယခင်က",
  "Next":"နောက်ထပ်",
  "Try Again":"တဖန်",
  "Next Level":"နောက်တစ်ဆင့်",
  "Profile":"ကိုယ်ရေးအချက်အလက်",
  "Current Hiragana Level":"လက်ရှိ ဟိရဂနာ အဆင့်",
  language:"ဘာသာစကား ရွေးချယ်ရန်",
  Unsucscribe:"စာရင်းမှ ရုပ်သိမ်းမည်",
  back:"နောက်သို့",
  Replay:"ပြန်လည်ဖြေကြားရန်",
  English:"အင်္ဂလိပ်",
  Japanese:"ဂျပန်",
  Roma_ji:"ရိုမဂျီ",
  loginTips:"ဖုန်းနံပါတ်ထည့်သွင်းပါ",
  subscribe:'စာရင်းသွင်းရန်',
  FAQ:"မေးလေ့ရှိသောမေးခွန်းများ",
  TC:"စည်းမျဉ်းနှင့် သတ်မှတ်ချက်များ",
  getCode:"ထပ်မံပို့ပါ",
  register:"မှတ်ပုံတင်ရန်",
  phoneNumber:"ဖုန်းနံပါတ်",
  Daily:"နေ့စဉ်",
  Weekly:"အပတ်စဉ်",
  pleaseWait:"ကျေးဇူးပြု၍ စောင့်ပါ",
  loading:"ဆောင်ရွက်နေသည်",
  Submit:"တင်သွင်းပါ",
  Confirm:"အတည်ပြုပါ",
  OK:"အိုကေ",
  change:"ပြောင်းလဲရန်",
  Myanmar:"မြန်မာ",
  Copyright:"© ၂၀၂၅ မူပိုင်ခွင့်များ အားလုံးရယူထားသည်။",
  select_level:"ပြန်လည်သုံးသပ်မှု စတင်ရန်",
  select_level_tip1:"ယခုစတင်ပါ",
  select_level_tip2:"ဒါကို ကျော်ပါ",
  level_1_title:"သင့်ခရီးစဉ် ဤနေရာမှ စတင်ပါသည်",
  level_1_tip:"သင့်သည် ဘဝနှင့်ယဉ်ကျေးမှု အဆင့်တွင် ရှိပါသည်။ ဘာသာစကားအတွက် ခိုင်မာသော အခြေခံအုတ်မြစ်ချရန် အကောင်းဆုံးအဆင့်ဖြစ်ပါသည်။",
  level_1_btn:"ခရီးစတင်ပါ",
  level_2_title:"အလွန်တိုးတက်မှုရှိပါတယ်!",
  level_2_tip:"သဒ္ဒါ အဆင့်သို့ ရောက်ရှိပြီ စကားပြော၊ သဒ္ဒါနှင့် ကျွမ်းကျင်မှုကို မြှင့်တင်ရန် အချိန်တန်ပါပြီ",
  level_2_btn:"ဆက်လက်ကြိုးစားပါ",
  level_3_title:"အထင်ကရ ကျွမ်းကျင်မှုများ!",
  level_3_tip:"သင့်သည် စကားဝိုင်း အဆင့်သို့ ရောက်ရှိပါပြီ။မိခင်ဘာသာစကားပြောသကဲ့သို့ ကျွမ်းကျင်စွာ ပြောဆိုနားလည်နိုင်ရန် ပြင်ဆင်လိုက်ပါ။",
  level_3_btn:"ကျွမ်းကျင်မှု အဆင့်စတင်ရန်",
  level_again:"အဆင့်ပြန်လည်သတ်မှတ်ခြင်း",
  current_level:"လက်ရှိအဆင့်",
  Re_admission:"ပြန်လည်အပ်နှံခြင်း စာမေးပွဲ",
  Re_testing:"ပြန်လည်စစ်ဆေးခြင်း",
  Grammar_tips:"ကျေးဇူးပြု၍ ဘဝနဲ့ယဥ်ကျေးမှု သင်တန်းကို အရင်ဆုံးပြီးအောင်လုပ်ပါ",
  Conversation_tips:"ကျေးဇူးပြု၍ သဒ္ဒါ သင်တန်းကို အရင်ဆုံးပြီးအောင်လုပ်ပါ",
  in_process:"ဆောင်ရွက်နေသည်။",
  no_start:"မစတင်ရသေးပါ",
  finished:"ပြီးဆုံးပါပြီ",
  books:"စာအုပ်များ",
  guidance:"လမ်းညွှန်ချက်",
  test_level_tip:"သင့်ဘာသာစကားအဆင့်သိရှိရန် အတိုချုံးပြန်လည်သုံးသပ်ခြင်းတစ်ခု ပြုလုပ်ပါ",
  LifeCulture_guidance_title:"ဘဝနဲ့ ယဥ်ကျေးမှု အတန်းမှ ကြိုဆိုပါတယ်",
  LifeCulture_guidance_tip:"ကျွန်ုပ်တို့သည် ဖင်ယင် (Pinyin) မှစတင်ပြီး သင့်အား အဆင့်ဆင့် လမ်းညွှန်ပေးသွားမည်။ဖင်ယင်သင်တန်း ပြီးဆုံးပါက ပိုမိုစိတ်လှုပ်ရှားဖွယ်သင်ခန်းစာများကို အလိုလျောက် ရယူနိုင်မည်ဖြစ်သည်!" ,
  Grammar_guidance_title:"သဒ္ဒါ အတန်းမှ ကြိုဆိုပါတယ်",
  Grammar_guidance_tip:"စိုးရိမ်မနေပါနဲ့၊ အဆင့်ဆင့် လိုက်ပြီး သင်ယူနိုင်ပါတယ်။ အတန်းအားလုံးကို ပြီးစီးလိုက်ရင် ပိုစိတ်ဝင်စားဖွယ်ကောင်းတဲ့ အကြောင်းအရာများကို ဖွင့်နိုင်မှာဖြစ်ပါတယ်။. ဆက်လက်ကြိုးစားပါ!" ,
  advance_guidance_title:"အဆင့်မြင့် အတန်းသို့ ကြိုဆိုပါသည်",
  advance_guidance_tip:"သင်အတွက် သင်ခန်းစာအားလုံးကို ဖွင့်ထားပြီးဖြစ်ပါသည်။ အပြည့်အဝ ခံစားပြီး ပျော်ရွှင်လိုက်ပါ!" ,
  book_title:"သင့်တော်သော စာအုပ်များ" ,
  book_tip:"အဆင့်အားလုံးသို့ သင့်တော်ပြီး၊ လေ့လာရလွယ်ကူပြီး ပျော်ရွှင်စွာ သုံးနိုင်ရန် ဒီဇိုင်းထားသော စာအုပ်များ!" ,
  load_book:"စာအုပ်အကြောင်းအရာကို လုပ်ဆောင်နေဆဲ…",
  load_book_failed:"စာအုပ်အကြောင်းအရာ ဖွင့်ရန် မအောင်မြင်ပါ",
  reload:"ပြန်လည်ဖွင့်မည်",
  copyLink:"လင့်ခ်ကို ကူးမည်",
  downTips1:'ကျေးဇူးပြုပြီး လင့်ခ်ကို ဘရောက်ဇာတွင် ကူးပြီး ဒေါင်းလုဒ်လုပ်ပါ။',
  CopySucceeded:'ကူးယူမှု အောင်မြင်ပါသည်',
  CopyFailed:'ကူးယူမှု မအောင်မြင်ပါ',
  home:'ပင်မစာမျက်နှာ',
  Select_Topics:'အကြောင်းအရာများ ရွေးချယ်ရန်',
  Select_Can_do:'Can-do များကို ရွေးချယ်ပါ',
  Practice:'လေ့ကျင့်မှု',
  Back:'နောက်သို့',
  NEXT_STEP:'နောက်တစ်ဆင့်',
  Challenge:'စိန်ခေါ်မှု',
  Kanji:"ခန်းဂျီး",
  KanjiTips1:"နေ့စဉ်ဘဝအတွက် အဓိကစာလုံးများကို ကျွမ်းကျင်အောင်လုပ်ပါ",
  Hiragana:"ဟိရဂန ",
  HiraganaTips1:"အသံထွက်၊ ဖတ်ခြင်း၊ ရေးခြင်းအတွက် အခြေခံ ဟိရဂနကို သင်ယူပါ",
  katakana:"ခတခန",
  katakanaTips1:"အသံထွက်၊ ဖတ်ခြင်း၊ ရေးခြင်းအတွက် ခတခန ကို ကျွမ်းကျင်အောင်လုပ်ပါ",
  Lessons:"သင်ခန်းစာများ",
  Key_phrase:"အဓိက စကားစု",
  Scripts:"စာသားများ",
  grammar_tips:"စာပေ အကြံပြုချက်များ",
  Topic:"ခေါင်းစဉ်",
  Detail:"အကြောင်းအရာ",
  ANIMATION:"ရုပ်ရှင်လှုပ်ရှားမှု",
  MEMORY_HINT:"မှတ်ဉာဏ် အကြံပြုချက်",
  EXAMPLES:"နမူနာများ",
  Choose_the:"… အတွက် ဖတ်စရာကို ရွေးချယ်ပါ",
  underlined:"အောက်တွင်မျဉ်းတားထားသော",
  word:"စကားလုံး",
  Answer:"အဖြေ",
  VOCABULARIES:"ဝေါဟာရများ",
  Katakana_Practice:"ကတာကာနာ လေ့ကျင့်မှု",
  Katakana_tip_1:"အသံထွက်ကို နားဆင်ပါ",
  Katakana_tip_2:"ပြီးနောက် ကတာကာနာကို ရွေးချယ်ပါ။",
  Click_to_listen:"နားဆင်ရန် နှိပ်ပါ",
  Hiragana_Practice:"ဟိရာဂနာ လေ့ကျင့်မှု",
  Hiragana_tip_2:"ပြီးနောက် ဟိရာဂနာကို ရွေးချယ်ပါ။",
  Close:"ပိတ်မည်",
  Choose_Lesson:"သင်ခန်းစာကို ရွေးချယ်ပါ",
  Lesson:"သင်ခန်းစာ",
  Skit:"အတိုချုပ် ဇာတ်ကြောင်း",
  Video:"ဗီဒီယို",
  Listen:"နားဆင်ပါ",
  Download:"ဒေါင်းလုဒ်လုပ်ပါ",
  select_pick_tip:"ဘာသာစကားတစ်ခုရွေးချယ်ပြီး ဒီနေ့ပဲ စတင်လိုက်ပါ!",
  Selected:"ရွေးချယ်ထားသော",
  Beginner:'အခြေခံ',
  Intermediate:'အလယ်အလတ်',
  Advanced:'အဆင့်မြင့်',
  sharePanelTitle:'သူငယ်ချင်းများထံ မျှဝေပါ',
  sharePanelTips:'အောက်ပါ platform များထဲမှ တစ်ခုကိုရွေးပြီး invite link ကို တိုက်ရိုက်ပို့လိုက်ပါ။',
  shareMore:'အခြား App များသို့ မျှဝေမယ်',
  referralTips1:"စိတ်ဝင်စားစရာတစ်ခုတွေ့လို့ ခင်ဗျားနဲ့ မျှဝေချင်ပါတယ်။ လာပါ၊ ကျွန်တော်နဲ့ ပူးပေါင်းပါ။",
}



// WEBPACK FOOTER //
// ./src/assets/i18n/bur.js